export const PAGE_SIZES = [10, 20, 50, 100];
export const RECENT_PAGE_SIZE_KEY = "recentPageSize";
export const DEFAULT_PAGE_SIZE = 10;

export enum PaginationQueryParams {
  Page = "page",
  Limit = "limit",
}
